import { Minus } from 'lucide-react';
import React from 'react';
import { cn } from '~/util';
import { fromNumeric, getCountryFlagUrl } from '~/util/countries';
interface FlagProps {
    countryCode?: string | number;
    className?: string;
}

const MissingCountryFlag = ({ className }: { className?: string }) => (
    <Minus className={cn('min-w-8 min-h-8 max-w-8 max-h-8', className)} />
);

const Flag: React.FC<FlagProps> = ({ countryCode, className }) => {
    if (!countryCode || countryCode == 0) {
        return <MissingCountryFlag className={className} />;
    }

    const countryData = fromNumeric(countryCode);

    if (!countryData) {
        return <MissingCountryFlag className={className} />;
    }

    const flagUrl = getCountryFlagUrl(countryData);

    return (
        <img
            src={flagUrl}
            alt={`${countryData.alpha2}`}
            className={cn(
                'min-w-8 min-h-8 max-w-8 max-h-8 object-contain',
                className,
            )}
        />
    );
};

export default Flag;
